// extracted by mini-css-extract-plugin
module.exports = {"container":"NotResult_container__10Uwy","default":"NotResult_default__3l4Rd","fav":"NotResult_fav__mxNKL"};